// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"72":"87085576","511":"c33864df","884":"3b2d5ab2","886":"c9eac079"}[chunkId] + ".js";
};